export const getHostApis = () => ({
  chrome: window?.chrome,
  shift: window?.chrome?.shift,
  onelaunch: window?.chrome?.onelaunch,
})
